export default function CopyIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 7C6 6.44772 6.44772 6 7 6H13C13.5523 6 14 6.44772 14 7V10H17C17.5523 10 18 10.4477 18 11V17C18 17.5523 17.5523 18 17 18H11C10.4477 18 10 17.5523 10 17V14H7C6.44772 14 6 13.5523 6 13V7ZM12 13V16H16V12H13H12V13ZM12 10H11C10.4477 10 10 10.4477 10 11V12H8V8H12V10Z"
        fill="var(--text-primary-color)"
      />
    </svg>
  );
}
